module.exports = __webpack_public_path__ + "img/MOVE.5b0e07e0.svg";